import { DialogContent, DialogContentText } from '@mui/material'

interface Props {
  firstLine: string
  secondLine: string
}

const HeaderDialogContent = ({ firstLine, secondLine }: Props) => {
  return (
    <DialogContent>
      <DialogContentText>
        {firstLine}
        <br />
        {secondLine}
      </DialogContentText>
    </DialogContent>
  )
}

export default HeaderDialogContent
